import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { MyAccessPage } from "./pages/MyAccessPage";
import { MyFilesPage } from "./pages/MyFilesPage";
import { AccountPage } from "./pages/AccountPage";
import { DatabasesPage } from "./pages/DatabasesPage";
import { OAuthClientsPage } from "./pages/OAuthClientsPage";
import { ContextPage } from "./pages/ContextPage";

function ProtectedRoute({ children, adminOnly = false }: { children: JSX.Element; adminOnly?: boolean }) {
  const { token, me, loading } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  if (loading) return <FullScreenSpinner />;
  if (adminOnly && me && !me.is_admin) return <Navigate to="/" replace />;
  return children;
}

function FullScreenSpinner() {
  return (
    <div className="flex h-screen items-center justify-center text-slate-500 text-sm">
      Loading…
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/me/grants" element={<MyAccessPage />} />
        <Route path="/me/files" element={<MyFilesPage />} />
        <Route
          path="/admin/account"
          element={
            <ProtectedRoute adminOnly>
              <AccountPage />
            </ProtectedRoute>
          }
        />
        <Route path="/admin/users" element={<Navigate to="/admin/account" replace />} />
        <Route
          path="/admin/databases"
          element={
            <ProtectedRoute adminOnly>
              <DatabasesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/oauth"
          element={
            <ProtectedRoute adminOnly>
              <OAuthClientsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/context"
          element={
            <ProtectedRoute adminOnly>
              <ContextPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
